import React from 'react';
import IconSystem from 'icon-collection/icon-systems';
import PlaceholderReportScreen from './PlaceholderReportScreen';

const ComplimentaryReportScreen: React.FC = () => (
  <PlaceholderReportScreen
    title="Complimentary Bookings"
    description="Original rate, complimentary value, remarks and approval details for comp stays."
    icon={<IconSystem.tag size={18} />}
    phaseLabel="Coming in Phase 3"
    comingSoonHint="Complimentary value foregone, reasons, and the approving manager."
  />
);
export default ComplimentaryReportScreen;
